import React from 'react';
import { KatLink } from '@amzn/katal-react';
import * as constants from '../appConstants';

import './App.scss';

export class HelpHeader extends React.Component<{region: string}> {

    constructor(props: Readonly<{ region: string; }>) {
        super(props);
    }

    render() {
        let helpLink = constants.LINK_SCRATCHPAD_HELP;
        if (this.props.region === "jp") {
            helpLink = constants.LINK_SCRATCHPAD_HELP_JP;
        }

        return (
            <div>
                <KatLink
                    href={helpLink}
                    label="Help"
                    target="_blank"
                />
                <br/>
                <KatLink
                    href={constants.LINK_API_HELP}
                    label="API Guide"
                    target="_blank"
                />
            </div>

        );
    }
}

export default HelpHeader;
